import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import vensoRepository from "@/services/VensoRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export function removeDeliveryNoticeItem(groupId, accessToken, item) {
    return new RemoveDeliveryNoticeItem(groupId, accessToken, item)
        .enqueue();
}
export default class RemoveDeliveryNoticeItem extends AbstractCommand {
    groupId;
    accessToken;
    item;
    constructor(groupId, accessToken, item) {
        super();
        this.groupId = groupId;
        this.accessToken = accessToken;
        this.item = item;
    }
    async execute() {
        try {
            await vensoRepository.removeDeliveryNoticeItem(this.groupId, this.accessToken, this.item);
        }
        catch (e) {
            alerts.error(trans(`${this.name()}.error`));
            throw e;
        }
    }
    name() {
        return 'remove_delivery_notice_item';
    }
}
